import React from 'react';
import PropTypes from 'prop-types';
import { ArrowDropDown, ArrowDropUp } from '@sparkpost/matchbox-icons';
import { Heading } from 'src/components/text';
import styles from './MetricDisplay.module.scss';

function MetricDisplay(props) {
  const { value, label, direction, color } = props;

  let Icon = null;

  if (direction === 'up') {
    Icon = ArrowDropUp;
  }

  if (direction === 'down') {
    Icon = ArrowDropDown;
  }

  return (
    <div className={styles.MetricDisplay} data-id={props['data-id']}>
      <Heading as="h4" className={styles.Label}>
        {label}
      </Heading>
      <Heading as="h5" className={styles.Value}>
        {value}

        {/* eslint-disable-next-line */}
        {Icon && <Icon className={styles.Icon} size={35} style={{ color }} />}
      </Heading>
    </div>
  );
}

MetricDisplay.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['up', 'down']),
  color: PropTypes.string
};

export default MetricDisplay;
